import useAppContext from "@src/modules/App/hooks/useAppContext";
import { DicomViewerState } from "@src/modules/DicomViewer/hooks/useDicomViewerVisibility";
import { FunctionComponent, useEffect } from "react";
import { useParams } from "react-router";

const DicomViewerHandler: FunctionComponent = () => {
  const { dicomViewer } = useAppContext();
  const { studyId } = useParams<{ studyId?: string }>();

  useEffect(() => {
    dicomViewer.setStudyId(studyId);
    dicomViewer.setState(DicomViewerState.Visible);

    return () => {
      dicomViewer.setState(DicomViewerState.Hidden);
      dicomViewer.setStudyId(undefined);
    };
  }, [dicomViewer, studyId]);

  return null;
};

export default DicomViewerHandler;
